export const appsAppGroupIdChartsFormulaData = "/apps/:app_group_id/charts/formula_data";
